<template>
  <tabs
    v-if="accom"
    :tab-name="['Detail', 'Notes']"
    :tab-icon="['event_available', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <accom-edit :accom="accom" />
    </template>

    <template slot="tab-pane-2">
      <accom-tabs-notes :accom="accom" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";
import accomApi from "@/services/api/accom";

import AccomEdit from "./AccomEdit";
import AccomTabsNotes from "./AccomTabsNotes";

export default {
  props: ["accom"],

  components: {
    Tabs,
    AccomEdit,
    AccomTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
};
</script>
